const GITLAB_TAG_LINK = 'https://gitlab.mediarex.com/mediarex/chiliz/capsicum/-/tags/';
const GITLAB_REF_LINK = 'https://gitlab.mediarex.com/mediarex/chiliz/capsicum/-/tree/';

type UseGitLabTagShape = {
	commit?: string;
	link?: string;
	title?: string;
};

export const useGitLabTag = (tag = '', commit = ''): UseGitLabTagShape => {
	if (tag && tag !== 'integration') {
		const releaseRegex = /[a-zA-Z]{3}-[a-zA-Z]{3}-v?\d+.\d+.\d+/;
		const isRelease = releaseRegex.test(tag);

		if (isRelease) {
			return {
				commit: undefined,
				link: `${GITLAB_TAG_LINK}${tag}`,
				title: tag
			};
		}
		const [date, sha] = tag.split('.');

		return {
			commit: sha,
			link: `${GITLAB_TAG_LINK}${tag}`,
			title: date
		};
	}

	if (commit) {
		return {
			commit: commit,
			link: `${GITLAB_REF_LINK}${commit}`,
			title: commit.substring(0, 7)
		};
	}

	return {
		commit: undefined,
		link: undefined,
		title: undefined
	};
};
